import PropTypes from 'prop-types';
import React from 'react';

const ArrowLeft = ({ size, ...props }) => (<svg
    width={(size / 0.95)}
    height={size}
    viewBox="0 0 20 19"
    {...props}
>
    <path
        d="M3.9 7.9L9.2 2C9.6 1.5 9.6 0.7 9.1 0.3 8.6-0.2 7.8-0.1 7.4 0.4L0.6 8.1C0.4 8.2 0.2 8.4 0.1 8.5 -0.1 8.9 0 9.5 0.3 9.8L7.4 17.7C7.6 17.9 8 18.1 8.3 18.1 8.6 18.1 8.8 18 9.1 17.8 9.6 17.3 9.6 16.6 9.2 16.1L3.9 10.2 18.8 10.2C19.4 10.2 20 9.6 20 9 20 8.4 19.4 7.9 18.7 7.9L3.9 7.9Z" // eslint-disable-line
    />
</svg>);

ArrowLeft.propTypes = {
    size: PropTypes.number,
};

ArrowLeft.defaultProps = {
    size: 19,
};

export default ArrowLeft;



// WEBPACK FOOTER //
// ./src/client/Components/Icons/ArrowLeft.js